// extracted by mini-css-extract-plugin
export default {"TabbedContainer":"IpLwIri0","TabPanel":"WOpJXxRo"};